<template>
  <section class="content">
    <box title="Filtro">
      <div slot="body">
        <div class="row">
            <div class="col-md-12">
                <input class="form-control" placeholder="Nome do serviço ..." type="text" v-model="filter">
            </div>
        </div>
        <div class="row">
          <div class="col-md-2" style="display: flex">
              <router-link class="padding" to="/novo-servico" >
                <button class="btn btn-primary" >Novo Serviço</button>
              </router-link>
          </div>
        </div>     
      </div>
    </box>  

    <box>
        <div slot="body">
          <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
          <div class="row">
              <div class="col-sm-6">
              <div id="example1_length" class="dataTables_length">

              </div>
              </div>
          </div>
          <div class="row">
              <div class="col-sm-12 table-responsive" id="table">
              <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr>
                      <th v-for="coluna in headers">
                          <a href="javascript:;" @click="orderProduto(coluna)" >{{coluna | ucwords}}</a>
                      </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="s in servicos">
                      <td>{{s.id}}</td>
                      <td class="sorting_1">{{s.nome}}</td>
                      <td>{{s.descricao}}</td>
                      <td><img :src="s.imagem" class="url_imagem"></td>
                      <td>{{s.tempo}}</td>
                      <td>{{s.preco}}</td>
                      <td>
                        <i :class="'fa fa-circle ativo_'+s.ativo" aria-hidden="true" title=""></i>
                      </td>
                      <td>
                        <div class="grupo_btn_acoes">
                          <router-link :to="{name: 'Editar Serviço', params: { id: s.id}}" class="btn_editar">
                            <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                          </router-link>
                          <i class="fa fa-trash-o btn_prod_excluir" aria-hidden="true" @click="excluir(s.id)"></i>
                        </div>
                      </td>
                  </tr>
                                          
                  </tbody>
                  <tfoot>
                  <tr>
                      <th v-for="coluna in colunas">
                          <a href="javascript:;" @click="orderProduto(coluna)">{{coluna | ucwords}}</a>
                      </th>
                  </tr>
                  </tfoot>
              </table>
              </div>
          </div>
        </div>
                <!-- /.box-body -->
      </div>
    </box>   
  </section>
</template>

<script>
import NovoServico from './novoServico';
import resourceServicos from './resource';
import Box from '../Box' // importando box

export default {
    components: {
        appNovoServico: NovoServico,
        'box': Box
    },
    data () {
      return {
        search: '',
        servicos: [],
        idExcluir: null,
        editId: null,
        headers: ['ID', 'Imagem', 'Nome', 'Descricao', 'Tempo', 'Preço', 'Ativo', 'Ações' ],
        loading: true
      }
    },
    created() {
      this.getServicos()
    },
    methods: {
      getServicos() {
        this.editId = null;
        this.idExcluir = null;
        resourceServicos.getListaServicos().then((response) => {
          this.servicos = response.data
        }).catch(err => {
          console.log('erro => ', err);
        })
      },
      editServico(id) {
        this.editId = id;
      },
      excluir (id) {
      this.$swal({
        title: 'Tem certeza que deseja excluir?',
        text: "Você não poderá reverter isto!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, delete!',
        cancelButtonText: 'Não, cancele!',
        confirmButtonClass: 'btn btn-success',
        cancelButtonClass: 'btn btn-danger',
        buttonsStyling: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          resourceServicos.dellServico(id).then((res) => {
            this.getServicos();
            this.$swal({
              position: 'top-end',
              type: 'success',
              title: 'Excluída com sucesso',
              showConfirmButton: false,
              timer: 1500
            })          
          }).catch((err) => {
            this.$swal(
                'Ops',
                'Ocorreu um erro na exclusão da categoria.',
                'error'
              )
          })
        }
      })
    },
  }
}
</script>
<style scoped>
.icon-devedores {
  padding-right: 5%;
  padding-top: 20px; 
}
.icon-edit:hover{
  color: dodgerblue!important;
}
.icon-delete:hover{
  color: red!important;
}
.icon-list:hover{
  color: green!important;  
}
.btnMenu {
  margin-top: -10px;
}
</style>




// WEBPACK FOOTER //
// Servicos.vue?4c373a7a